import type { NavItem } from '@/app/nav';
import SidebarSubItemList from './SidebarSubItemList';

interface RailFlyoutProps {
    id: string;
    title: string;
    items: NonNullable<NavItem['subItems']>;
    isActive: (path: string) => boolean;
    top: number;
    maxHeight: number;
    ref: React.Ref<HTMLDivElement>;
}

/** A parent item's sub-links beside the rail; positioned and dismissed by useRailFlyout. */
export default function RailFlyout({ id, title, items, isActive, top, maxHeight, ref }: RailFlyoutProps) {
    return (
        <div
            id={id}
            ref={ref}
            style={{ top, maxHeight }}
            className="fixed left-24 w-56 overflow-y-auto rounded-2xl border border-mp-border bg-mp-surface p-3 shadow-theme-lg"
        >
            <p className="px-3 pt-1 pb-2 font-heading text-theme-2xs font-semibold uppercase text-mp-muted">{title}</p>
            <SidebarSubItemList items={items} isActive={isActive} className="flex flex-col gap-0.5" />
        </div>
    );
}
